import dataCenter from './data-center';
import identity from './identity';
import contract from './contract';
import images from './images';
import snapshots from './snapshots';
import lan from './lan';
import storage from './storage';
import sshKey from './ssh-key';
import common from './common';
import group from './group';
import user from './user';
import server from './server';
import kubernetes from './kubernetes';
import billing from './billing';
import ip from './ip';
import loadbalancer from './load-balancer';
import nic from './nic';
import reseller from './reseller';
import s3 from './s3';
import backupUnit from './backup-unit';
import networkLoadbalancer from './network-load-balancer';
import applicationLoadbalancer from './application-load-balancer';
import template from './template';
import monitoring from './monitoring';
import natGateway from './nat-gateway';
import autoScaling from './auto-scaling';
import location from './location';
import adServer from './ad-server';
import certificateManager from './certificate-manager';
import database from './database';
import targetGroup from './target-group';
import containerRegistry from './container-registry';

export const service = {
  identity,
  contract,
  images,
  snapshots,
  dataCenter,
  lan,
  storage,
  sshKey,
  common,
  group,
  user,
  server,
  kubernetes,
  billing,
  ip,
  loadbalancer,
  nic,
  reseller,
  s3,
  backupUnit,
  networkLoadbalancer,
  applicationLoadbalancer,
  template,
  monitoring,
  natGateway,
  autoScaling,
  location,
  adServer,
  certificateManager,
  database,
  targetGroup,
  containerRegistry,
};
